export function getToken () {
  return window.localStorage.getItem('__soa_token__')
}

export function setToken (token) {
  return window.localStorage.setItem('__soa_token__', token)
}

export function getEmail () {
  return window.localStorage.getItem('__soa_email__')
}

export function setEmail (email) {
  return window.localStorage.setItem('__soa_email__', email)
}
